import { render, staticRenderFns } from "./ChangeCustomerCompanyDialog.vue?vue&type=template&id=cff22b3c"
import script from "./ChangeCustomerCompanyDialog.vue?vue&type=script&lang=js"
export * from "./ChangeCustomerCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports